// utils/customAlert.js
import { isValidElement } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "sweetalert2/dist/sweetalert2.min.css";

const MySwal = withReactContent(Swal);

/* ---------- Inject improved, snappy animations (UPDATED CSS) ---------- */
const injectStyles = () => {
  if (typeof document === "undefined") return;
  if (document.getElementById("swal-snappy-animations")) return;

  const css = `
  /* popup basics */
  .swal2-popup.custom-swal {
    width: 460px !important;
    max-width: 94% !important;
    padding: 28px !important;
    border-radius: 14px !important;
    font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
    box-shadow: 0 14px 40px rgba(12,20,30,0.12), 0 6px 18px rgba(12,20,30,0.06);
    color: #0f1720;
  }
  .swal2-icon.custom-icon {
    width: 88px !important;
    height: 88px !important;
    display: block !important;
    margin: 6px auto 14px auto !important;
    padding: 10px !important;
    text-align: center;
    line-height: 0;
    box-shadow: 0 10px 30px rgba(2,6,23,0.06) !important;
    background: transparent !important;
    position: relative;
    overflow: visible;
  }
  .custom-icon svg { display:block; margin:0 auto; }
  .swal2-title.custom-title {
    display: block !important;
    text-align: center !important;
    font-size: 22px !important;
    font-weight: 600 !important;
    margin: 6px 0 8px !important;
    color: #22313f !important;
  }
  .swal2-html-container.custom-text {
    font-size: 16px !important;
    line-height: 1.6 !important;
    color: #324048 !important;
    margin-top: 6px !important;
    font-weight: 600 !important;
    text-align: center !important;
  }
  .custom-text ul { display:inline-block; text-align:left; padding-left:20px; margin:8px 0 0 0; }
  .custom-text li { margin:6px 0; font-weight:600; font-size:15px; }

  .swal2-actions .swal2-confirm, .swal2-actions .swal2-cancel {
    padding: 10px 18px !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    border-radius: 10px !important;
    min-width: 96px;
  }

  /* --- [CHANGE START]: Cancel Button Styling (Light Gray & Visible) --- */
  .swal2-actions .swal2-cancel {
    background: #f3f6f9 !important; /* Light Gray Background */
    color: #495057 !important;     /* Dark Gray Text for visibility */
    border: 1px solid #d8dbe0 !important; /* Visible Border */
    box-shadow: 0 1px 2px rgba(0,0,0,0.05) !important;
  }
  .swal2-actions .swal2-cancel:hover {
    background: #e2e6ea !important; /* Slightly darker on hover */
    color: #212529 !important;
  }
  /* --- [CHANGE END] --- */

  .swal2-actions .swal2-cancel { display:none !important; }
  .swal2-popup.custom-swal.has-cancel .swal2-actions .swal2-cancel { display:inline-block !important; }

  /* per-type container color & shape */
  .swal2-icon.custom-icon.success { background: rgba(16,185,129,0.08) !important; color:#059669 !important; border-radius:50% !important; }
  .swal2-icon.custom-icon.error   { background: rgba(220,38,38,0.06) !important; color:#dc2626 !important; border-radius:50% !important; }
  .swal2-icon.custom-icon.warning { background: rgba(249,115,22,0.08) !important; color:#c2410c !important; border-radius:10px !important; }
  .swal2-icon.custom-icon.info    { background: rgba(37,99,235,0.06) !important; color:#2563eb !important; border-radius:50% !important; }
  
  /* Question Icon Style */
  .swal2-icon.custom-icon.question{ background: rgba(64, 81, 137, 0.1) !important; color:#405189 !important; border-radius:50% !important; }

  /* Animations (UNCHANGED) */
  .icon-draw path, .icon-draw circle, .icon-draw line {
    stroke-dasharray: 140;
    stroke-dashoffset: 140;
    animation:
      draw-quick 0.28s cubic-bezier(.2,.9,.2,1) forwards,
      emphasis-pop 0.25s 0.28s cubic-bezier(.2,.9,.2,1) forwards,
      accent-subtle 1.1s 0.55s ease-in-out infinite;
    transform-origin: center;
  }
  .icon-shake path, .icon-shake line {
    stroke-dasharray: 140;
    stroke-dashoffset: 140;
    animation:
      draw-quick 0.28s cubic-bezier(.2,.9,.2,1) forwards,
      accent-shake 0.9s 0.28s ease-in-out infinite;
    transform-origin: center;
  }
  .icon-pop path, .icon-pop circle, .icon-pop line {
    animation:
      emphasis-pop 0.23s cubic-bezier(.2,.9,.2,1) forwards,
      accent-wiggle 0.9s 0.23s ease-in-out infinite;
    transform-origin: center;
  }
  .icon-rotate svg { 
    animation:
      draw-quick 0.28s cubic-bezier(.2,.9,.2,1) forwards,
      accent-rotate 1.2s 0.28s ease-in-out infinite;
    transform-origin: center;
  }
  .icon-bounce path, .icon-bounce circle {
    stroke-dasharray: 140;
    stroke-dashoffset: 140;
    animation:
      draw-quick 0.28s cubic-bezier(.2,.9,.2,1) forwards,
      emphasis-bounce 0.28s 0.28s cubic-bezier(.2,.9,.2,1) forwards,
      accent-bounce 1s 0.6s ease-in-out infinite;
    transform-origin: center;
  }

  @keyframes draw-quick { to { stroke-dashoffset: 0; } }
  @keyframes emphasis-pop { 0% { transform: scale(1); opacity: 1; } 60% { transform: scale(1.08); opacity: 1; } 100% { transform: scale(1); opacity: 1; } }
  @keyframes emphasis-bounce { 0% { transform: translateY(0); } 40% { transform: translateY(-8px); } 100% { transform: translateY(0); } }
  @keyframes accent-subtle { 0% { transform: scale(1); opacity: 1; } 50% { transform: scale(1.02); opacity: 0.96; } 100% { transform: scale(1); opacity: 1; } }
  @keyframes accent-shake { 0% { transform: translateX(0) scale(1); } 20% { transform: translateX(-4px) scale(1.02); } 40% { transform: translateX(4px)  scale(1.02); } 60% { transform: translateX(-2px) scale(1.01); } 100% { transform: translateX(0) scale(1); } }
  @keyframes accent-wiggle { 0% { transform: rotate(0deg); } 30% { transform: rotate(-6deg); } 60% { transform: rotate(4deg); } 100% { transform: rotate(0deg); } }
  @keyframes accent-rotate { 0% { transform: rotate(0deg) scale(1); } 40% { transform: rotate(12deg) scale(1.03); } 100% { transform: rotate(0deg) scale(1); } }
  @keyframes accent-bounce { 0% { transform: translateY(0) scale(1); } 30% { transform: translateY(-6px) scale(1.03); } 60% { transform: translateY(0) scale(1); } 100% { transform: translateY(0) scale(1); } }

  @media (max-width:420px) {
    .swal2-popup.custom-swal { padding:20px !important; width:92% !important; }
    .swal2-icon.custom-icon { width:64px !important; height:64px !important; padding:8px !important; }
    .swal2-title.custom-title { font-size:20px !important; }
    .swal2-html-container.custom-text { font-size:15px !important; }
    .swal2-actions .swal2-confirm, .swal2-actions .swal2-cancel { width:100% !important; display:block !important; margin-bottom:8px !important; }
    .swal2-actions { display:flex !important; flex-direction:column-reverse !important; }
    .swal2-popup.custom-swal .swal2-actions .swal2-cancel { display:none !important; }
    .swal2-popup.custom-swal.has-cancel .swal2-actions .swal2-cancel { display:block !important; }
    .custom-text ul { font-size:14px; }
    .custom-text li { font-size:14px; }
  }
  `;

  const node = document.createElement("style");
  node.id = "swal-snappy-animations";
  node.innerHTML = css;
  document.head.appendChild(node);
};
injectStyles();

/* ---------- Per-type modern SVGs (UNCHANGED) ---------- */
const svgs = {
  success: `
    <svg class="icon-draw" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
      <path d="M20 7L10.8 17.2L5 11.4" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`,
  error: `
    <svg class="icon-shake" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
      <path d="M18 6L6 18" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6 6l12 12" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`,
  warning: `
    <svg class="icon-pop" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
      <path d="M12 3L2 19h20L12 3z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" fill="none"/>
      <path d="M12 9v4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
      <path d="M12 17h.01" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    </svg>`,
  info: `
    <svg class="icon-rotate" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.1" fill="none"/>
      <path d="M11 11h2v5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 8h.01" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    </svg>`,
  question: `
    <svg class="icon-bounce" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
      <path d="M9 9a3 3 0 1 1 6 1c0 1.6-1.5 2.2-1.5 2.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 17h.01" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    </svg>`,
};

const typeConfigs = {
  success: { iconHtml: svgs.success, confirmColor: "#10b981", popupClassShape: "success" },
  error: { iconHtml: svgs.error, confirmColor: "#dc2626", popupClassShape: "error" },
  warning: { iconHtml: svgs.warning, confirmColor: "#d97706", popupClassShape: "warning" },
  info: { iconHtml: svgs.info, confirmColor: "#2563eb", popupClassShape: "info" },
  // [CHANGE START]: Updated confirm color to #405189
  question: { iconHtml: svgs.question, confirmColor: "#405189", popupClassShape: "question" },
};

/* ---------------- Utility (JSX Support) ---------------- */
const normalizeMessageToHtml = message => {
  if (isValidElement(message)) return message;

  if (Array.isArray(message)) {
    const escapeHtml = str =>
      String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    const items = message.map(m => `<li>${escapeHtml(m)}</li>`).join("");
    return `<div><ul>${items}</ul></div>`;
  }

  const escape = str =>
    String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  return `<div><p style="margin:0">${escape(message)}</p></div>`;
};

/* ---------------- Core: showAlert ---------------- */
export const showAlert = ({
  type = "info",
  title = "",
  text = "",
  confirmButtonText = "OK",
  cancelButtonText = "Cancel",
  showCancelButton = false,
  onConfirm = null,
  onCancel = null,
  allowOutsideClick = false,
  autoCloseMs = 0,
  preConfirm = null,
} = {}) => {
  const cfg = typeConfigs[type] || typeConfigs.info;
  const htmlContent = normalizeMessageToHtml(text);
  const popupClass = showCancelButton ? `custom-swal has-cancel` : `custom-swal`;

  MySwal.fire({
    customClass: {
      popup: popupClass,
      title: "custom-title",
      icon: `custom-icon ${cfg.popupClassShape}`,
      htmlContainer: "custom-text",
    },
    icon: type,
    iconHtml: cfg.iconHtml,
    title,
    html: htmlContent,
    showCancelButton,
    confirmButtonText,
    cancelButtonText,
    confirmButtonColor: cfg.confirmColor,
    cancelButtonColor: "#9aa6b2", // This is fallback, CSS overrides it

    showLoaderOnConfirm: !!preConfirm,
    preConfirm: preConfirm,
    allowOutsideClick: preConfirm ? () => !Swal.isLoading() : allowOutsideClick,

    timer: autoCloseMs && autoCloseMs > 0 ? autoCloseMs : undefined,
    timerProgressBar: autoCloseMs && autoCloseMs > 0 ? true : undefined,
    showClass: { popup: "animate__animated animate__fadeInDown" },
    hideClass: { popup: "animate__animated animate__fadeOutUp" },
  }).then(result => {
    if (result.isConfirmed && typeof onConfirm === "function") onConfirm();
    else if (result.dismiss === Swal.DismissReason.cancel && typeof onCancel === "function")
      onCancel();
  });
};

/* ---------------- showError ---------------- */
export const showError = (message, onClose = null, autoCloseMs = null) => {
  const htmlMessage = normalizeMessageToHtml(message);

  const opts = {
    icon: "error",
    title: "<p style='margin:0;font-size:22px;font-weight:600;'>Error</p>",
    html: htmlMessage,
    confirmButtonText: "OK",
    confirmButtonColor: typeConfigs.error.confirmColor,
    allowOutsideClick: false,
    customClass: {
      popup: "custom-swal",
      title: "custom-title",
      icon: "custom-icon error",
      htmlContainer: "custom-text",
    },
    iconHtml: typeConfigs.error.iconHtml,
    didClose: () => {
      if (typeof onClose === "function") {
        onClose();
      }
    },
  };

  if (typeof autoCloseMs === "number" && autoCloseMs > 0) {
    opts.timer = autoCloseMs;
    opts.timerProgressBar = true;
  }

  // Promise (.then) use karne ki ab zaroorat nahi kyunki didClose sab sambhal lega
  MySwal.fire(opts);
};

/* ---------------- Shortcuts ---------------- */
export const showSuccess = (message, onOk, autoCloseMs = 0) =>
  showAlert({
    type: "success",
    title: "Success",
    text: message,
    confirmButtonText: "OK",
    onConfirm: onOk,
    autoCloseMs,
  });

export const showWarning = (message, onOk = null, autoCloseMs = 0) =>
  showAlert({
    type: "warning",
    title: "Warning",
    text: message,
    confirmButtonText: "OK",
    onConfirm: onOk,
    autoCloseMs,
  });

/* ---------------- showConfirm ---------------- */
export const showConfirm = (message, onConfirm, onCancel) =>
  showAlert({
    type: "question",
    title: "Are you sure?",
    text: message,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    showCancelButton: true,

    preConfirm: async () => {
      if (typeof onConfirm === "function") {
        try {
          return await onConfirm();
        } catch (e) {
          Swal.showValidationMessage(`Request failed: ${e.message || e}`);
          console.error("onConfirm callback error:", e);
          return false;
        }
      }
    },

    onCancel: () => {
      if (typeof onCancel === "function") {
        try {
          onCancel();
        } catch (e) {
          console.error("onCancel callback error:", e);
        }
      }
    },
  });

export default { showError, showSuccess, showConfirm, showAlert };
